import Loader from "app/components/Loader";
import * as React from "react";
import { lazyLoad } from "utils/loadable";

export const Projects = lazyLoad(
  () => import("./index"),
  (module) => module.ProjectsPages,
  {
    fallback: <Loader />,
  }
);
